import type { NewsItem } from "@/types/film";

export const newsList: NewsItem[] = [
  {
    id: "n1",
    title: "「蜜桃成熟时3D」发布首支正式预告，定档国庆黄金周",
    summary:
      "历时三年筹备，影片首支3D正式预告今日上线，浓缩呈现蜜桃园四季与主人公的成长轨迹，并宣布将于国庆黄金周与观众见面。",
    content:
      "今日，电影「蜜桃成熟时3D」正式发布首支全长预告片，并宣布定档国庆黄金周。预告片以一段长达四十秒的无对白长镜头开场，镜头从蜜桃园的晨雾中缓缓升起，阳光穿过枝叶洒在尚带露珠的果实上，3D景深带来的空间感让不少提前观看的媒体直呼「像真的站在树下」。\n\n随后，画面转入主人公苏蜜与江樾的初遇、离别与重逢三条线索。导演在预告结尾埋下一句旁白：「有些味道，要等很多年才尝得出来。」片方表示，这句台词是全片的情感核心，也呼应了片名中「成熟」二字的双重含义。\n\n制片方透露，影片全片采用实景与3D结合的方式拍摄，蜜桃园的四季场景均取自真实果园，通过前期长达一年的定点拍摄积累素材，再由后期团队完成立体呈现。预告片发布两小时内，相关话题便登上多个平台热搜榜。",
    date: "2026-09-18",
    author: "本站记者 沈知",
    category: "影片动态",
    image:
      "https://readdy.ai/api/search-image?query=modern%20cinema%20theater%20interior%20with%20warm%20amber%20ambient%20lighting%20and%20empty%20velvet%20seats%2C%20soft%20focus%2C%20elegant%20editorial%20photography%2C%20warm%20peach%20color%20grade%2C%20high%20detail&width=800&height=600&seq=peach-news-01&orientation=landscape",
    tags: ["预告片", "定档", "3D"],
  },
  {
    id: "n2",
    title: "导演专访：如何用3D技术重构一段关于成长的故事",
    summary:
      "导演在专访中坦言，3D不是噱头，而是让观众「靠近人物内心」的方式。他分享了影片在叙事与技术上的一次次取舍。",
    content:
      "在影片正式定档后，导演接受了本站的独家专访。谈到为何选择3D这一形式，他表示：「我们想做的不是让东西飞出来吓人，而是让你觉得，你就坐在蜜桃园里，能闻到风里的甜味。」\n\n为了这个目标，剧组在拍摄阶段就建立了完整的立体数据流程，每一个关键场景都要同时记录机位、光照与空间信息，后期再用这些数据重建景深。导演承认，这样的方式让拍摄周期比常规影片延长了近一倍，「但我们愿意为那种真实感付出代价。」\n\n谈到叙事，导演强调影片并不会因为技术而牺牲情感：「3D只是把观众拉近一点，真正留住人的还是人物之间的关系。苏蜜为什么离开，江樾为什么留下，这些才是我想讲清楚的。」",
    date: "2026-09-10",
    author: "本站记者 陆行舟",
    category: "幕后访谈",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20a%20film%20clapperboard%20and%20rolled%20script%20on%20a%20warm%20wooden%20table%20with%20soft%20golden%20light%2C%20editorial%20style%2C%20warm%20tones%2C%20clean%20simple%20background%2C%20high%20detail&width=800&height=600&seq=peach-news-02&orientation=landscape",
    tags: ["专访", "导演", "幕后"],
  },
  {
    id: "n3",
    title: "「蜜桃成熟时3D」亮相国际电影节，首映场观众反响热烈",
    summary:
      "影片受邀参加国际电影节展映单元，全球首映场座无虚席。映后交流持续近一小时，观众对影片的情感表达给予高度评价。",
    content:
      "本周，电影「蜜桃成熟时3D」受邀亮相国际电影节展映单元，并举行全球首映。放映厅内座无虚席，不少观众在影片结束后仍留在原地交流感受。\n\n映后交流环节，导演携主创团队登台，与观众分享了影片从构思到完成的完整历程。有观众提问，影片为何选择把最动人的一场戏放在雨夜，导演回应：「那场雨下了很久，就像两个人之间没说出口的话。」\n\n多家海外媒体在映后给出评价，认为影片「在技术与情感之间找到了难得的平衡」，尤其称赞3D画面没有喧宾夺主，反而让人物关系更具温度。片方表示，后续还将陆续公布多个国家和地区的上映计划。",
    date: "2026-08-29",
    author: "本站驻会记者 苏叶",
    category: "影展资讯",
    image:
      "https://readdy.ai/api/search-image?query=elegant%20film%20festival%20red%20carpet%20scene%20at%20warm%20dusk%20with%20soft%20glowing%20lights%2C%20blurred%20background%20bokeh%2C%20warm%20amber%20palette%2C%20cinematic%20editorial%20photo%2C%20high%20detail&width=800&height=600&seq=peach-news-03&orientation=landscape",
    tags: ["电影节", "首映", "口碑"],
  },
  {
    id: "n4",
    title: "幕后特辑曝光：3D拍摄如何呈现蜜桃园四季光影",
    summary:
      "最新幕后特辑公开了剧组长达一年的定点拍摄过程。摄影师如何用同一机位记录四季变化，成为特辑中最受关注的细节。",
    content:
      "片方今日发布一支幕后特辑，聚焦影片中最具标志性的「蜜桃园四季」。为了真实呈现季节流转，剧组在同一机位进行了累计超过一年的定点拍摄，从初春的嫩芽一直记录到盛夏果实累累。\n\n摄影指导在特辑中介绍，为了让四季切换在3D画面中自然衔接，团队为每个季节都设计了独立的光照方案，并在后期将不同季节的素材统一到同一套空间坐标系中。「观众看到的是一次顺畅的转场，但背后是几百天的等待。」\n\n特辑还公开了立体摄像设备的组装与校准过程，展示了三维景深是如何在现场被精确记录的。片方表示，完整的幕后纪录片将在影片上映后择期推出。",
    date: "2026-08-15",
    author: "本站记者 沈知",
    category: "幕后访谈",
    image:
      "https://readdy.ai/api/search-image?query=behind%20the%20scenes%20film%20set%20with%20camera%20equipment%20under%20warm%20golden%20studio%20light%2C%20soft%20haze%2C%20cinematic%20editorial%20photography%2C%20amber%20tones%2C%20high%20detail&width=800&height=600&seq=peach-news-04&orientation=landscape",
    tags: ["幕后", "特辑", "摄影"],
  },
  {
    id: "n5",
    title: "主演阵容首次合体亮相发布会，分享拍摄趣事",
    summary:
      "四位主演在发布会上首次同台，聊起在蜜桃园拍摄的日子，既有烈日下的坚持，也有收工后分食果实的轻松时刻。",
    content:
      "在今日举行的定档发布会上，影片四位主演首次同台亮相。谈及拍摄经历，饰演苏蜜的演员笑称，自己在蜜桃园里「晒黑了好几个色号」，但也因此真正理解了角色对那片土地的眷恋。\n\n饰演江樾的演员则分享了一场让他印象深刻的戏：「那是一场在站台上的告别，导演要求我们真的等一列火车开走。火车过去之后，风里都是果香，那一刻不需要演。」\n\n发布会现场还播放了一段拍摄花絮，记录了剧组在收工后共同分食蜜桃的轻松时刻。主演们表示，正是这些日常的相处，让彼此在镜头前的关系更加自然可信。",
    date: "2026-08-06",
    author: "本站记者 陆行舟",
    category: "影片动态",
    image:
      "https://readdy.ai/api/search-image?query=artistic%203d%20glasses%20and%20cinema%20tickets%20lying%20on%20a%20soft%20peach%20colored%20surface%20with%20warm%20light%2C%20minimal%20product%20photography%2C%20warm%20tones%2C%20clean%20simple%20background%2C%20high%20detail&width=800&height=600&seq=peach-news-05&orientation=landscape",
    tags: ["发布会", "主演", "花絮"],
  },
  {
    id: "n6",
    title: "「蜜桃成熟时3D」主题曲MV上线，将在片尾完整呈现",
    summary:
      "由民谣歌手演绎的主题曲《成熟的季节》MV正式上线，歌曲以克制的旋律呼应影片主题，将在片尾字幕阶段完整播放。",
    content:
      "影片主题曲《成熟的季节》MV今日正式上线。歌曲由一位长期致力于民谣创作的歌手演绎，旋律克制而悠长，歌词以蜜桃的成熟隐喻人物内心的成长。\n\n据片方介绍，主题曲并不会在影片中段出现，而是完整地放在片尾字幕阶段。「我们希望观众带着电影的情绪离场，这首歌就是那段余韵。」导演在采访中这样解释。\n\nMV的拍摄同样取景于蜜桃园，采用自然光拍摄，画面与影片保持了统一的暖色调。上线数小时内，歌曲便进入多个音乐平台的新歌榜单。",
    date: "2026-07-28",
    author: "本站记者 苏叶",
    category: "影片动态",
    image:
      "https://readdy.ai/api/search-image?query=warm%20sunset%20sky%20over%20a%20quiet%20coastal%20town%20with%20soft%20glowing%20clouds%2C%20cinematic%20wide%20landscape%2C%20peach%20and%20amber%20gradient%20palette%2C%20dreamy%20atmospheric%2C%20high%20detail&width=800&height=600&seq=peach-news-06&orientation=landscape",
    tags: ["主题曲", "MV", "音乐"],
  },
  {
    id: "n7",
    title: "影片取景地探访：那座被蜜桃香气包裹的海边小镇",
    summary:
      "跟随剧组足迹走访影片主要取景地。小镇的清晨、集市与海岸线，几乎原封不动地出现在大银幕上。",
    content:
      "影片的大部分外景取自一座临海的小镇。据当地居民回忆，剧组进驻的那几个月，是小镇多年来最热闹的一段时光。\n\n记者走访发现，影片中那座贯穿全片的蜜桃园就在小镇北侧的缓坡上，如今已进入采摘季，枝头挂满沉甸甸的果实。园主说，剧组离开时把一部分道具和布景留了下来，如今成了不少游客的打卡点。\n\n影片中反复出现的集市与海堤，也都能在现实中一一对应。当地文旅部门表示，随着影片上映临近，已有不少影迷提前前来探访，小镇正在准备相应的导览服务。",
    date: "2026-07-12",
    author: "本站记者 沈知",
    category: "取景地",
    image:
      "https://readdy.ai/api/search-image?query=warm%20sunlit%20seaside%20town%20overlooking%20a%20calm%20sea%20at%20golden%20hour%2C%20cinematic%20landscape%20photography%2C%20peach%20and%20amber%20tones%2C%20gentle%20atmospheric%20mood%2C%20high%20detail&width=800&height=600&seq=peach-news-07&orientation=landscape",
    tags: ["取景地", "旅行", "幕后"],
  },
  {
    id: "n8",
    title: "口碑解禁：观众盛赞3D画面的沉浸感与情感力量",
    summary:
      "首批媒体与观众口碑正式解禁，普遍认为影片在技术呈现之外，更打动人心的仍是那份朴素而克制的情感。",
    content:
      "随着首映结束，影片的平台口碑正式解禁。综合多家媒体与观众的评价，影片在技术呈现与情感表达两方面均获得较高认可。\n\n有评论写道：「3D在这部电影里不是奇观，而是呼吸。你会不知不觉地相信，自己就站在那片蜜桃园里。」也有观众表示，影片最打动自己的并非视觉，而是两位主人公之间那种「没说出口却无处不在」的牵挂。\n\n当然，也有部分评价认为影片节奏偏慢。对此导演在采访中回应：「这是一个需要慢慢品味的故事，就像等一颗蜜桃成熟。」片方表示，欢迎观众带着自己的感受走进影院，得出属于自己的答案。",
    date: "2026-06-30",
    author: "本站评论员 顾未",
    category: "口碑评价",
    image:
      "https://readdy.ai/api/search-image?query=vintage%20film%20projector%20casting%20warm%20light%20beams%20in%20a%20dark%20room%2C%20cinematic%20atmospheric%20scene%2C%20amber%20glow%2C%20artistic%20photography%2C%20high%20detail&width=800&height=600&seq=peach-news-08&orientation=landscape",
    tags: ["口碑", "评论", "影评"],
  },
];